import * as yup from 'yup'

export const advanceConfirmationSchema = yup.object().shape({
  signature: yup.string().required(),
})

export type AdvanceConfirmationFormSchema = yup.InferType<
  typeof advanceConfirmationSchema
>
